<div
  class="dashboard-papaya"
  [ngClass]="{'dashboard-papaya_zoomed-view': isZoomedView()}"
  (rtElementResized)="updateContentSize()"
>
  <div class="dashboard-papaya__content-fitter" #contentFitter>
    <!-- Keep empty to fit content. -->
    <!-- Papaya isn't very good at resizing itself, so we use this element to get the right size. -->
  </div>

  @let showLoader = viewerState() !== DashboardStudyViewerLoadingState.notInitialized && viewerState() !== DashboardStudyViewerLoadingState.viewerRendered;
  <div
    class="dashboard-papaya__content"
    #content
    [ngClass]="{'dashboard-papaya__content_loading': showLoader}"
    (rtElementResized)="updatePapayaSize()"
  >
    @if (showLoader) {
      <app-dashboard-study-viewer-loader></app-dashboard-study-viewer-loader>
    }

    @if (isZoomedView()) {
      <app-dashboard-study-viewer-zoomed-controls></app-dashboard-study-viewer-zoomed-controls>
    }

    @if (studyViewerMode() === dashboardStudyViewerMode.SurfaceWithProfile) {
      <img
        class="dashboard-papaya__head-outline"
        ngSrc="/assets/images/dashboard/papaya/papayaviewer_skull-image.webp"
        alt="skull_image"
        height="2466"
        width="2455"
        priority="true"
      >
    }

    <div
      class="papaya"
      [ngClass]="{
        'papaya_initializing': !isPapayaRendered(),
      }"
      data-params="papayaParams"
    ></div>
  </div>

  @if (isPapayaRendered() && !isZoomedView()) {
    <div class="study-viewer__viewer-controls">
      <app-dashboard-study-viewer-controls></app-dashboard-study-viewer-controls>
    </div>
  }
</div>
